import appConfig from '../../configs/appConfig';
import languageCodes from '../../consts/localization/languageCodes';
import {setLanguageCode} from '../../state/slice/session';
import {dispatch} from '../../state/store';
import storageService from '../storageService';
import {userBrowserService} from '../userBrowserService';
import localizationCountryService from './localizationCountryService';

const getSystemLanguageCode = () => userBrowserService.getSystemLanguage()?.toUpperCase();

const getUserLanguageCode = (marketCode) =>
    storageService.getLanguageCodeFromLocalStorage() ??
    appConfig.getDefaultLanguageCode(marketCode) ??
    languageCodes.SYSTEM;

const handleLanguageCode = (languageCode) => {
    return languageCode === languageCodes.SYSTEM ? getSystemLanguageCode() : languageCode;
};

const saveLanguageCodeToStorage = (languageCode) => {
    if (!languageCode) return;

    dispatch(setLanguageCode(languageCode));

    storageService.setLanguageCodeToLocalStorage(languageCode);
};

const checkIsItDefaultLanguage = (countryCode, languageCode) => {
    const language = handleLanguageCode(languageCode);

    const defaultLanguageCode = appConfig.getDefaultLanguageCode(countryCode);

    return language === defaultLanguageCode;
};

const getAvailableLanguages = () => {
    const countryCode = localizationCountryService.getUserCountryCodeFromLocalStorage();

    return appConfig.getMarketLanguages(countryCode);
};

const getIsLanguageSettingDisabled = () => {
    const availableLanguages = getAvailableLanguages();

    return !availableLanguages || availableLanguages.length <= 1;
};

export default {
    handleLanguageCode,
    getUserLanguageCode,
    checkIsItDefaultLanguage,
    saveLanguageCodeToStorage,
    getIsLanguageSettingDisabled,
};
